import { collection, getDocs } from "firebase/firestore";
import { useLoaderData } from "react-router-dom";
import ExportTableAsCSV from "../components/ExportTableAsCSV";
import { db } from "../firebase/config";

function PlevenOpenRequests() {
  const usersList = [];
  const result = useLoaderData(plevenOpenRequestsLoader);

  result.forEach((doc) => {
    usersList.push({ id: doc.id, ...doc.data() });
    usersList.sort((a, b) => b.date - a.date);
  });

  return (
    <div className="container py-8 mx-auto">
      <ExportTableAsCSV
        tableData={document.querySelector(".plevenOpenRequestsTable")}
        fileName="Pleven_Open_Days_2026.csv"
      />
      <div className="grid grid-cols-7 gap-0 p-2 text-white bg-fordBlue plevenOpenRequestsTable">
        <h4>Име</h4>
        <h4 className="text-center">Имейл</h4>
        <h4 className="text-center">Телефон</h4>
        <h4 className="text-center">Тип</h4>
        <h4 className="text-center">Модел</h4>
        <h4 className="text-center">Период</h4>
        <h4 className="text-center">Дата</h4>
      </div>
      {usersList.map((user) => (
        <div
          className="grid grid-cols-7 gap-2 p-2 border-b text-fordBlue even:bg-gray-50 hover:bg-gray-200 offerTableRow"
          key={user.id}
        >
          <p>{user.name}</p>
          <p className="text-center">{user.email}</p>
          <p className="text-center">{user.phone}</p>
          <p className="text-center">
            {user.requestType === "testdrive" ? "Тест драйв" : "Оферта"}
          </p>
          <p className="text-center">{user.model}</p>
          <p className="text-center">{user.preferredDate || "-"}</p>
          <p className="text-center">
            {user.date?.toDate?.().toLocaleDateString("bg-BG")}
          </p>
        </div>
      ))}
    </div>
  );
}

export default PlevenOpenRequests;

export const plevenOpenRequestsLoader = async () => {
  const querySnapshot = await getDocs(collection(db, "pleven-open-days-2026"));
  return querySnapshot;
};
